// import { Injectable } from '@angular/core';
// import {
//   HttpRequest,
//   HttpHandler,
//   HttpEvent,
//   HttpInterceptor,
//   HttpErrorResponse
// } from '@angular/common/http';
// import { Observable, throwError } from 'rxjs';
// import { UserService } from '../_services';
// import { Router } from '@angular/router';
// import { catchError } from 'rxjs/operators';
// declare var $: any;

// @Injectable()
// export class HttpErrorInterceptor implements HttpInterceptor {

//   constructor(private _US: UserService, private router: Router) { }

//   intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
//     return next.handle(request).pipe(
//       catchError((error: HttpErrorResponse) => {
//         let errMsg = "";
//         // Client Side Error
//         if (error.error instanceof ErrorEvent) {
//           errMsg = `Error: ${error.error.message}`;
//         } else if (error.status === 401 || error.status === 440) {
//           // Server Side Error
//           errMsg = `Error Code: ${error.status},  Message: ${error.message}`;
//           // if (error.error.meta.action === "logout") {
//           this._US.updateUserAuth(false, null);
//           localStorage.clear();
//           // $('#offcanvasToplogin').offcanvas('show');
//           //}
//         }
//         return throwError(() => new Error(errMsg));
//       })
//     );
//   }
// }


import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { UserService } from '../_services';
import { Router } from '@angular/router';
import { catchError } from 'rxjs/operators';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(private _US: UserService, private router: Router) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
                
         if (error.status === 301 || error.status === 302 || error.status === 404 || error.status === 410) {
            return throwError(() => error);
         }
        
        let errMsg = '';

        // Client-side error
        if (error.error instanceof ErrorEvent) {
          errMsg = `Client Error: ${error.error.message}`;
        }
        // Unauthorized or session expired
        else if (error.status === 401 || error.status === 440) {
          errMsg = `Error Code: ${error.status}, Message: ${error.message}`;
          this._US.updateUserAuth(false, null);
          localStorage.clear();
          // Optionally, redirect to login page
          // this.router.navigate(['/login']);
        }
        // Other server-side errors
        else {
          errMsg = `Error Code: ${error.status}, Message: ${error.message}`;
        }

        return throwError(() => new Error(errMsg));

      })
    );
  }
}
